/* Static JS extracted from the product template custom blocks (Oct 2026) */
/* ===== size-chart (block custom_liquid_ircmQD, part 1) ===== */
try{
(function(){
const modal = document.getElementById("sizeModal");

document.getElementById("openSizeChart").onclick = () => {
  document.body.appendChild(modal); // 🔥 force to root
  modal.classList.add("active");
  document.body.style.overflow = "hidden";
};

document.getElementById("closeSizeChart").onclick = () => {
  modal.classList.remove("active");
  document.body.style.overflow = "";
};

modal.onclick = (e) => {
  if (e.target === modal) {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }
};

document.addEventListener("keydown", (e) => {
  if (e.key === "Escape") {
    modal.classList.remove("active");
    document.body.style.overflow = "";
  }
});
})();
}catch(e){}

/* ===== stock-counter (block custom_liquid_tjkX7K, part 1) ===== */
try{
(function(){
document.addEventListener('DOMContentLoaded', function () {

    // SETTINGS
    const min = 2;
    const max = 16;

    // stock reduces by this amount on refresh
    const reduceByMin = 1;
    const reduceByMax = 2;

    // reset after 24 hours
    const resetHours = 24;

    const stockElement = document.getElementById('random-stock');

    if (!stockElement) return;

    // unique storage per product page
    const storageKey = 'fakeStockData-' + window.location.pathname;

    const now = Date.now();

    let stockData = JSON.parse(localStorage.getItem(storageKey));

    // reset if expired or first visit
    if (
      !stockData ||
      !stockData.timestamp ||
      (now - stockData.timestamp) > resetHours * 60 * 60 * 1000
    ) {

      stockData = {
        stock: Math.floor(Math.random() * (max - min + 1)) + min,
        timestamp: now
      };

    } else {

      let stock = stockData.stock;

      const reduction =
        Math.floor(Math.random() * (reduceByMax - reduceByMin + 1)) + reduceByMin;

      stock -= reduction;

      // never go below minimum
      if (stock < min) stock = min;

      stockData.stock = stock;
      stockData.timestamp = now;
    }

    // save updated value
    localStorage.setItem(storageKey, JSON.stringify(stockData));

    // display stock
    stockElement.textContent = stockData.stock;

  });
})();
}catch(e){}

/* ===== wishlist-button (block custom_liquid_8j3Dij, part 1) ===== */
try{
(function(){
(function() {

  class WishlistAllCustom extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'rooshy_wishlist';
    }

    connectedCallback() {
      this.init();
      window.addEventListener('wishlist-updated', () => this.updateState());
    }

    init() {
      this.initProductButton();
      this.updateState();
    }

    getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(this.storageKey)) || [];
      } catch (e) {
        return [];
      }
    }

    saveWishlist(wishlist) {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
      window.dispatchEvent(new CustomEvent('wishlist-updated'));
    }

    // ✅ FIX 1: ignore invalid items
    isInWishlist(productId) {
      return this.getWishlist()
        .filter(item => item && item.id && item.title)
        .some(item => item.id === productId);
    }

    // ✅ FIX 2: prevent bad data from entering
    addToWishlist(productData) {
      if (!productData.id || !productData.title) return;

      const wishlist = this.getWishlist();
      if (!this.isInWishlist(productData.id)) {
        wishlist.push(productData);
        this.saveWishlist(wishlist);
      }
    }

    removeFromWishlist(productId) {
      let wishlist = this.getWishlist();
      wishlist = wishlist.filter(item => item.id !== productId);
      this.saveWishlist(wishlist);
    }

    initProductButton() {
      const button = this.querySelector('.ai-wishlist-btn-custom');
      if (!button) return;

      const productId = button.dataset.productId;

      if (this.isInWishlist(productId)) {
        this.setActive(button, true);
      }

      button.addEventListener('click', (e) => {
  e.preventDefault();

  const isActive = button.classList.contains('active');

  const addText = button.querySelector('.add-text');
  const removeText = button.querySelector('.remove-text');
  const icon = button.querySelector('.ai-wishlist-icon-custom');

  if (isActive) {

    this.removeFromWishlist(productId);
    this.setActive(button, false);

  } else {

    this.addToWishlist({
      id: productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      price: button.dataset.productPrice,
      image: button.dataset.productImage,
      url: button.dataset.productUrl
    });

    this.setActive(button, true);

    icon.classList.add('pop');

    if (removeText) {
  removeText.textContent = 'Added ✓';
}

clearTimeout(button._wishlistTimer);

button._wishlistTimer = setTimeout(() => {
  if (button.classList.contains('active') && removeText) {
    removeText.textContent = 'Remove from Wishlist';
  }

  icon.classList.remove('pop');
}, 1600);
  }
});
    }

    setActive(button, state) {
      const addText = button.querySelector('.add-text');
      const removeText = button.querySelector('.remove-text');

      if (state) {
        button.classList.add('active');
        button.setAttribute('aria-label', 'Remove from wishlist');
        if (addText && removeText) {
          addText.style.display = 'none';
          removeText.style.display = 'inline';
        }
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-label', 'Add to wishlist');
        if (addText && removeText) {
          addText.style.display = 'inline';
          removeText.style.display = 'none';
        }
      }
    }

    updateState() {
      const button = this.querySelector('.ai-wishlist-btn-custom');
      if (!button) return;

      const exists = this.isInWishlist(button.dataset.productId);
      this.setActive(button, exists);
    }
  }

  customElements.define('wishlist-all-custom', WishlistAllCustom);

})();
})();
}catch(e){}

/* ===== product-gallery (block custom_liquid_izhg9A, part 1) ===== */
try{
(function(){
(function () {

  const row = document.getElementById('pg-row');
  const dots = document.querySelectorAll('.pg__dot');
  const cards = document.querySelectorAll('.pg__card');


  // SNAP index detection
  const cardWidth = cards[0].offsetWidth + 8;
  row.addEventListener('scroll', () => {
    
   const maxScroll = row.scrollWidth - row.offsetWidth;

const index = (row.scrollLeft >= maxScroll - 5)
  ? cards.length - 1
  : Math.round(row.scrollLeft / cardWidth);

    dots.forEach((d, i) => {
      d.classList.toggle('active', i === index);
    });
  });

  // Tap video play
  row.addEventListener('click', function(e) {
    const card = e.target.closest('.pg__card');
    if (!card) return;

    const video = card.querySelector('.js-video');
    if (!video) return;

    document.querySelectorAll('.js-video').forEach(v => {
      if (v !== video) {
        v.pause();
        v.closest('.pg__card')?.classList.remove('is-playing');
      }
    });

    if (video.paused) {
      video.play().catch(()=>{});
      card.classList.add('is-playing');
    } else {
      video.pause();
      card.classList.remove('is-playing');
    }
  });

})();



// ================= INIT =================
const lightbox = document.getElementById('pg-lightbox');
const lightboxImg = document.getElementById('pg-lightbox-img');
const closeBtn = document.querySelector('.pg__lightbox-close');
const galleryImages = Array.from(document.querySelectorAll('.pg__card img'));
const counter = document.getElementById('pg-counter');
const SLIDE_EASE = 'transform 0.32s cubic-bezier(0.22, 1, 0.36, 1)';

function preloadImage(src) {
  const img = new Image();
  img.src = src;
}

function preloadNeighbours(index) {

  const next =
    galleryImages[(index + 1) % galleryImages.length];

  const prev =
    galleryImages[
      (index - 1 + galleryImages.length) %
      galleryImages.length
    ];

  preloadImage(next.dataset.full);
  preloadImage(prev.dataset.full);
}

let currentIndex = 0;
let scrollY = 0;

let isAnimating = false;

// move lightbox to body
if (lightbox && lightbox.parentNode !== document.body) {
  document.body.appendChild(lightbox);
}

// ================= OPEN =================
galleryImages.forEach((img, index) => {
  img.addEventListener('click', (e) => {
    e.stopPropagation();

    currentIndex = index;
const preload = new Image();

preload.onload = () => {

  lightboxImg.src = img.dataset.full;
  lightboxImg.alt = img.alt;

  counter.textContent =
    `${currentIndex + 1} / ${galleryImages.length}`;

};

preload.src = img.dataset.full;
	preloadNeighbours(currentIndex);

    scrollY = window.scrollY;

    document.body.style.cssText = `
      position: fixed;
      top: -${scrollY}px;
      width: 100%;
    `;

    lightbox.style.display = 'flex';

    requestAnimationFrame(() => {
      lightbox.classList.add('active');
    });
  });
});

// ================= CLOSE =================
function closeLightbox() {
  lightbox.classList.remove('active');

  document.body.style.cssText = '';

  document.documentElement.style.scrollBehavior = 'auto';
  window.scrollTo(0, scrollY);

  setTimeout(() => {
    document.documentElement.style.scrollBehavior = '';
  }, 50);

  setTimeout(() => {
    lightbox.style.display = 'none';
    lightboxImg.src = '';
  }, 200);
}

lightbox.addEventListener('click', (e) => {
  if (e.target === lightbox) closeLightbox();
});

closeBtn.addEventListener('click', (e) => {
  e.stopPropagation();
  closeLightbox();
});

// prevent close when clicking image
lightboxImg.addEventListener('click', (e) => e.stopPropagation());

// ================= SWIPE =================
let startX = 0;
let currentTranslate = 0;
let isDragging = false;
let hasMoved = false;

lightbox.addEventListener('touchstart', (e) => {
  if (isAnimating) return;
  if (!lightbox.classList.contains('active')) return;

  startX = e.touches[0].clientX;
  isDragging = true;
  hasMoved = false;
  currentTranslate = 0;

lightboxImg.style.transition = 'none';
});

lightbox.addEventListener('touchmove', (e) => {
  if (!isDragging) return;

  let diff = e.touches[0].clientX - startX;

  if (Math.abs(diff) > 25) {
    hasMoved = true;
  }

  currentTranslate = diff * 1.08;
  lightboxImg.style.transform = `translateX(${currentTranslate}px)`;
}, { passive: true });

lightbox.addEventListener('touchend', () => {

  if (isAnimating) return;

  if (!isDragging) return;

  isDragging = false;

  

  // 👉 IMPORTANT: ignore taps completely
  if (!hasMoved) {
    lightboxImg.style.transform = 'translateX(0)';
    return;
  }

  

  // instant reset (no animation)
if (Math.abs(currentTranslate) > 45) {
isAnimating = true;
  

const direction = currentTranslate < 0 ? -1 : 1;


  lightboxImg.style.transition = SLIDE_EASE;
  lightboxImg.style.transform = `translateX(${direction * -100}%)`;

  setTimeout(() => {

  currentIndex = direction === -1
    ? (currentIndex + 1) % galleryImages.length
    : (currentIndex - 1 + galleryImages.length) % galleryImages.length;

const nextSrc =
  galleryImages[currentIndex].dataset.full;

const nextAlt =
  galleryImages[currentIndex].alt;

const preload = new Image();

preload.onload = () => {

  lightboxImg.src = nextSrc;
  lightboxImg.alt = nextAlt;
  
    counter.textContent =
  `${currentIndex + 1} / ${galleryImages.length}`;

  preloadNeighbours(currentIndex);

  lightboxImg.style.transition = 'none';

  lightboxImg.style.transform =
    `translateX(${direction * 100}%)`;

  requestAnimationFrame(() => {

    lightboxImg.style.transition =
      SLIDE_EASE;

    lightboxImg.style.transform =
      'translateX(0)';

    isAnimating = false;
  });

};

preload.src = nextSrc;

  // ✅ ADD THIS
  

}, 320);
} else {

  lightboxImg.style.transition = SLIDE_EASE;
  lightboxImg.style.transform = 'translateX(0)';

}
});



const prevBtn = document.querySelector('.pg__nav--left');
const nextBtn = document.querySelector('.pg__nav--right');

if (prevBtn && nextBtn) {

  prevBtn.addEventListener('click', (e) => {
    e.stopPropagation();

    currentIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;


const nextSrc =
  galleryImages[currentIndex].dataset.full;

const preload = new Image();

preload.onload = () => {

  lightboxImg.src = nextSrc;

  counter.textContent =
    `${currentIndex + 1} / ${galleryImages.length}`;

  preloadNeighbours(currentIndex);

};

preload.src = nextSrc;
  });

  nextBtn.addEventListener('click', (e) => {

  e.stopPropagation();

  currentIndex =
    (currentIndex + 1) % galleryImages.length;

  const nextSrc =
    galleryImages[currentIndex].dataset.full;

  const preload = new Image();

  preload.onload = () => {

    lightboxImg.src = nextSrc;

    counter.textContent =
      `${currentIndex + 1} / ${galleryImages.length}`;

    preloadNeighbours(currentIndex);
  };

  preload.src = nextSrc;
});

}
})();
}catch(e){}

/* ===== people-counter (block custom_liquid_TAeHHM, part 1) ===== */
try{
(function(){
document.addEventListener('DOMContentLoaded', function () {

    // SETTINGS
    const min = 45;
    const max = 279;

    // max refresh movement
    const refreshVariation = 10;

    // live movement every interval
    const liveVariation = 18;

    // auto update timing
    const interval = 27000;

    const stockElement = document.getElementById('random-people');

    if (!stockElement) return;

    // unique per product page
    const storageKey = 'liveViewers-' + window.location.pathname;

    let stored = localStorage.getItem(storageKey);

    let current;

    // first visit to this product
    if (!stored) {

      current = Math.floor(Math.random() * (max - min + 1)) + min;

    } else {

      stored = parseInt(stored);

      // refresh changes only ±10
      const refreshChange =
        Math.floor(Math.random() * (refreshVariation * 2 + 1)) - refreshVariation;

      current = stored + refreshChange;

      // keep inside limits
      if (current < min) current = min;
      if (current > max) current = max;
    }

    // save refreshed value
    localStorage.setItem(storageKey, current);

    // show number
    stockElement.textContent = current;

    // live movement while staying on page
    function updateNumber() {

      const liveChange =
        Math.floor(Math.random() * (liveVariation * 2 + 1)) - liveVariation;

      current += liveChange;

      if (current < min) current = min;
      if (current > max) current = max;

      stockElement.textContent = current;

      // update saved value too
      localStorage.setItem(storageKey, current);
    }

    // auto update
    setInterval(updateNumber, interval);

  });
})();
}catch(e){}